// src/config/routes.ts
import Home from '../pages/index';
import Details from '../pages/details';
import Tutorials from '../pages/Tutorials';
import Documentation from '../pages/Documentation';
import Support from '../pages/Support';
import FAQs from '../pages/FAQs';
import AdminPanel from '../pages/AdminPanel';

export interface RouteConfig {
  path: string;
  name: string;
  icon?: string;
  component: React.ComponentType<any>;
  children?: RouteConfig[];
}

export const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'App Center',
    icon: 'bi-house',
    component: Home
    // children: [
    //   {
    //     path: '/home',
    //     name: 'RequestList',
    //     component: Home
    //   }
    // ]
  },
  {
    path: '/details/:appname',
    name: 'Details',
    icon: 'bi-house',
    component: Details,
    
  },
  {
    path: '/tutorials/:appname',
    name: 'Tutorials',
    icon: 'bi-house',
    component: Tutorials,
    
  },
  {
    path: '/documentation/:appname',
    name: 'Documentation',
    icon: 'bi-house',
    component: Documentation,
    
  },
  {
    path: '/support/:appname',
    name: 'Support',
    icon: 'bi-house',
    component: Support,
    
  },
  {
    path: '/faqs/:appname',
    name: 'FAQs',
    icon: 'bi-house',
    component: FAQs,
    
  },
  {
    path: '/admin',
    name: 'Admin',
    icon: 'bi-house',
    component:  () => AdminPanel('Users'),
    
  },
  {
    path: '/admin/apps',
    name: 'Apps Management',
    icon: 'bi-house',
    component: () => AdminPanel('Apps'),
    
  },

];

export default routes; 